const initialNotificationState = {
    current: {
        id: null,
        type: null,
        status: null,
        memo: null,
        created_by: {
            id: null,
            name: null,
        },
        action_data: {
            request: {
                id: null,
                getRoute: null,
                approveRoute: null,
            },
        },
    },
    request: {
        id: null,
        entity_id: null,
        entity_class: null,
        created_by_id: null,
        approved_by_id: null,
        approved_at: null,
        old_values: {},
        new_values: {},
        new_record: false,
        created_at: null,
        updated_at: null,
    },
};
const Notifications = {
    namespaced: true,
    state: {
        count: null,
        new_notifications_count: null,
        notifications: [],
        current: initialNotificationState.current,
        request: initialNotificationState.request,
    },
    getters: {
        getNotifications: (state) => {
            return state.notifications;
        },
    },
    mutations: {
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = notifications;
        },
        SET_COUNT(state, count) {
            state.count = count;
        },
        SET_CURRENT(state, current) {
            state.current = current;
        },
        SET_REQUEST(state, request) {
            state.request = request;
        },
        SET_NEW_NOTIFICATIONS_COUNT(state, count) {
            state.new_notifications_count = count;
        },
    },
    actions: {
        initWebsocket({ dispatch }) {
            dispatch('websockets/initUserChannel', {}, { root: true }).then((channel) => {
                channel.listen('notification-changed', () => {
                    dispatch('fetchNotifications');
                });
            });

            dispatch('websockets/initNotificationsChannel', {}, { root: true }).then((channel) => {
                channel.listen('refresh-notifications', () => {
                    dispatch('fetchNotifications');
                });
            });
        },
        fetchNotifications({ commit }) {
            axios
                .get(
                    route('api.v1.notifications.index', {
                        fields: 'id,status,memo,created_at,type,created_by.id,created_by.name,action_data,status',
                        meta: 'new_notifications_count',
                        limit: 12, //??
                        status: 'new',
                    })
                )
                .then((response) => {
                    let notifications = _.map(response.data.data, (notification) => {
                        notification.date = moment(notification.created_at);
                        notification.creator = notification.created_by;

                        if (!notification.creator) {
                            notification.creator = {
                                id: null,
                                name: '-',
                            };
                        }
                        return notification;
                    });

                    commit('SET_NOTIFICATIONS', notifications);
                    commit('SET_COUNT', response.data.meta?.pagination.total_items);
                    commit('SET_NEW_NOTIFICATIONS_COUNT', response.data.meta?.new_notifications_count);
                });
        },
        setCurrent({ commit }, current) {
            commit('SET_CURRENT', current);
        },
        setRequest({ commit }, request) {
            commit('SET_REQUEST', request);
        },
        resetRequest({ commit }) {
            commit('SET_REQUEST', {
                id: null,
                entity_id: null,
                entity_class: null,
                created_by_id: null,
                approved_by_id: null,
                approved_at: null,
                old_values: {},
                new_values: {},
                new_record: false,
                created_at: null,
                updated_at: null,
            });
        },
    },
};

export default Notifications;
